var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Feedback zur Aufgabe ändern"),
      confirmText: _vm.$gettext("Speichern"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Schließen"),
      closeClass: "cancel",
      height: "420",
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
      confirm: _vm.update,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _vm.localContent === ""
              ? _c("CompanionBox", {
                  attrs: {
                    mood: "pointing",
                    msgCompanion: _vm.$gettext(
                      "Sie haben kein Feedback geschrieben, beim Speichern wird dieses Feedback gelöscht!"
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c("label", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Feedback")) +
                      "\n                "
                  ),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localContent,
                        expression: "localContent",
                      },
                    ],
                    domProps: {
                      value: _vm.localContent,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.localContent = $event.target.value
                      },
                    },
                  }),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }